import {HTTP_REQUEST_AUTH} from "./requestAxios";
import {BLOG} from "@/constants/endPoints";

export const GetListBlog = (payload) => HTTP_REQUEST_AUTH.get(BLOG.GET_LIST_BLOG, {params: payload});
export const GetDetailBlog = (params) => HTTP_REQUEST_AUTH.get(BLOG.GET_DETAIL_BLOG+ '/'+params);
export const CreateBlog = (params) => HTTP_REQUEST_AUTH.post(BLOG.CREATE_BLOG, params);
export const UpdateBlog = (id,params) => HTTP_REQUEST_AUTH.put(BLOG.UPDATE_BLOG+'/'+ id,params );
export const DeleteBlog = (params) => HTTP_REQUEST_AUTH.delete(BLOG.DELETE_BLOG + '/'+  params);

